import useTranslation from '@app/hooks/use-translation';
import { formBaseButtonBlockStyles } from '@app/styles/base-styles';
import { Button, Upload } from '@ui';
import classNames from 'classnames';
import React, { FC, useState } from 'react';

const ImportContent: FC<{
  setImportModalState?: React.Dispatch<React.SetStateAction<boolean>>;
  onImportFile(result: Array<{ name: string } & Record<string, unknown>>): void;
}> = ({ setImportModalState, onImportFile }) => {
  const { t } = useTranslation('pages.dictionaries');

  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  function handleImportFiles() {
    const reader = new FileReader();
    reader.readAsText(uploadedFiles[0]);
    reader.onload = function (e) {
      const contents = JSON.parse(e?.target?.result as string) as Record<string, unknown>[];
      const filesNames = uploadedFiles[0].name.replace('.json', '').split('&');
      const result = contents.map((content, index) => ({ ...content, name: filesNames[index] }));
      onImportFile(result);
    };
  }
  return (
    <div>
      <Upload
        loadedFiles={uploadedFiles}
        fileAccept=".json"
        multiple={false}
        changeLoadedFiles={setUploadedFiles}
      />
      <div className={classNames(formBaseButtonBlockStyles, 'pb-[20px] !pt-[20px]')}>
        <Button onClick={handleImportFiles} label={t('import_selected_file')} />
        <Button onClick={() => setImportModalState?.(false)} label={t('cancel')} fill="linked" />
      </div>
    </div>
  );
};

export default ImportContent;
